import { apiClient } from "@/src/app/api/client";

export interface RegisterDetailsResponse {
  status: boolean;
  message: string;
  data: Array<{
    id: string;
    submission_data: any;
    // Add other fields if necessary based on user's JSON
  }>;
}

export async function getRegisterDetails(
  registrationId: string,
  domain: string
): Promise<RegisterDetailsResponse | null> {
  try {
    const response = await apiClient.get(
      `register-details/${registrationId}`,
      {
        headers: {
          "X-Domain": domain,
        },
      }
    );

    if (response.data?.status) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error(`Failed to fetch register details for ${registrationId}:`, error);
    return null;
  }
}
